module.exports = __webpack_public_path__ + "description.pdf";